import { JsonConverter, JsonCustomConvert } from 'json2typescript';

import { EmploymentSituation } from '../../../../../core';

@JsonConverter
export class EmploymentSituationAdapter implements JsonCustomConvert<EmploymentSituation | undefined> {
    serialize(situation: EmploymentSituation): any | undefined {
        return situation ? String(situation) : undefined;
    }

    deserialize(situation: any): EmploymentSituation | undefined {
        switch (situation) {
            case 'AJ':
                return EmploymentSituation.AS_EMPLOYEE;
            case 'SB':
                return EmploymentSituation.RECIPIENT_SUBSIDIES;
            case 'PR':
                return EmploymentSituation.SELF_EMPLOYED;
            case 'NR':
                return EmploymentSituation.UNPAID_ACTIVITY;
            case 'PN':
                return EmploymentSituation.PENSION;
            case 'DS':
                return EmploymentSituation.UNEMPLOYMENT;
            case 'RT':
                return EmploymentSituation.RENTS;
            default:
                return undefined;
        }
    }
}
